import { type StateCreator } from 'zustand';

/**
 * Refcount of page-owned selection bars currently mounted (collection bars, editor canvas bar).
 * When > 0, the agent space stays on the FAB phase instead of morphing into a second bar.
 */
export type PageOwnedSelectionBarSlice = {
  pageOwnedSelectionBarMountCount: number;
  registerPageOwnedSelectionBar: () => void;
  unregisterPageOwnedSelectionBar: () => void;
};

type CreatePageOwnedSelectionBarSlice = () => StateCreator<
  PageOwnedSelectionBarSlice,
  [],
  [],
  PageOwnedSelectionBarSlice
>;

export const createPageOwnedSelectionBarSlice: CreatePageOwnedSelectionBarSlice = () => (set) => ({
  pageOwnedSelectionBarMountCount: 0,
  registerPageOwnedSelectionBar: () =>
    set((state) => ({ pageOwnedSelectionBarMountCount: state.pageOwnedSelectionBarMountCount + 1 })),
  unregisterPageOwnedSelectionBar: () =>
    set((state) => ({
      pageOwnedSelectionBarMountCount: Math.max(0, state.pageOwnedSelectionBarMountCount - 1),
    })),
});
